module.exports = __webpack_public_path__ + "static/media/TETU.687d18ee.svg";